import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import frameworkGetters from './getters'
import customGetters from '@/config/store/getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const frameworkModulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const frameworkModules = frameworkModulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = frameworkModulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

// 自定义的store module
const customModulesFiles = require.context('@/config/store/modules', true, /\.js$/)
const customModules = customModulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const moduleFile = customModulesFiles(modulePath)
  modules[moduleName] = moduleFile.default
  return modules
}, {})



const getters = Object.assign(frameworkGetters, customGetters)
const modules = Object.assign(frameworkModules, customModules)

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [createPersistedState()]
})

export default store
